<template>
  <div class="login-div" data-vis-target="login-form">
    <form @submit.prevent="$parent.formSubmit()" action="#" class="login" data-session="sign-in">
      <h4 id="login-title" class="text-center" style="">تسجيل دخول</h4>
      <div :title="$t('nat_no')" class="input-field d-inline-flex w-100">
        <label class="icon-label" for="empNo"><font-awesome-icon :icon="['fas', 'user']" /></label>
        <input type="text" class="form-control" v-model="$parent.empNo" placeholder="الرقم الوظيفي" 
          pattern="^([0-9]){4,6}$" required="required">
      </div>
      <div :title="$t('reg_no')" class="input-field d-inline-flex w-100">
        <label class="icon-label" for="password"><font-awesome-icon :icon="['fas', 'key']" /></label>
        <input type="password" id="pass-field" class="form-control" v-model="$parent.password" placeholder="الرمز السري"
          autocomplete="off" required="required">
      </div>
      <button type="submit" class="btn btn-primary w-100">
        <font-awesome-icon :icon="['fas', 'magnifying-glass']" /> دخول
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: "SignForm",
};
</script>
